query AnalyticsSalesByEmailCampaign($filter: AnalyticsSalesFilterInput!, $limit: Int) {
  analyticsSales(filter: $filter) {
    currency
    salesByEmailCampaign(limit: $limit, includeRenewals: true) {
      automationId
      title
      sales
      revenue
    }
  }
}
